import { FileManager, Heading, RecordContent, RecordFooter, useTitleChange } from '@msaf/core-react'
import PublicDocumentLinks from '../../../../components/well-forms/documents/public-document-links'
import WellFileMetadata from '../../../../components/well-forms/documents/well-file-meta-data'
import WellViewButtons from '../../../../components/wells/well-view-buttons'
import { useGetWellData } from '../../../../hooks/use-api'
import { useWellId } from '../../../../hooks/use-well-id'

export default function ViewWellAdditionalDocuments() {
  useTitleChange('View Well | Additional Documents')
  const id = useWellId()
  const url = `wells/${id}/additional-documents/view`

  const { isLoading, data } = useGetWellData(url)

  return (
    <>
      <RecordContent>
        <Heading level={2}>Documents</Heading>
        <FileManager isSkeleton={isLoading} files={data?.state.files ?? []} getMetadataElement={WellFileMetadata} />
        <PublicDocumentLinks links={data?.state.publicDocumentLinks ?? []} />
      </RecordContent>
      <RecordFooter>
        <WellViewButtons wellId={id} />
      </RecordFooter>
    </>
  )
}
